export default "__VITE_ASSET__Bh1kKiF$__"